import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/ui/Button';
import './PrivacyPolicyPage.css';

const PrivacyPolicyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="privacy-policy-page">
      <div className="container">
        <div className="policy-header">
          <h1 className="page-title">Privacy Policy</h1>
          <p className="page-subtitle">Last updated: March 14, 2025</p>
        </div>
        
        <div className="policy-content">
          <section className="policy-section">
            <h2>1. Introduction</h2>
            <p>
              Welcome to Sign in Seconds ("we," "our," or "us"). We respect your privacy and are committed 
              to protecting your personal data. This privacy policy will inform you about how we look after 
              your personal data when you visit our website and use our e-signature services, regardless of 
              where you visit it from, and tell you about your privacy rights and how the law protects you.
            </p>
          </section>
          
          <section className="policy-section">
            <h2>2. Data We Collect</h2>
            <p>
              We may collect, use, store, and transfer different kinds of personal data about you, which we 
              have grouped together as follows:
            </p>
            <ul>
              <li><strong>Identity Data</strong> includes first name, last name, username or similar identifier.</li>
              <li><strong>Contact Data</strong> includes email address and telephone numbers.</li>
              <li><strong>Technical Data</strong> includes internet protocol (IP) address, your login data, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform, and other technology on the devices you use to access this website.</li>
              <li><strong>Usage Data</strong> includes information about how you use our website and services.</li>
              <li><strong>Document Data</strong> includes the content of documents you upload, signatures, and other information related to the e-signature process.</li>
            </ul>
          </section>
          
          <section className="policy-section">
            <h2>3. How We Use Your Data</h2>
            <p>
              We will only use your personal data when the law allows us to. Most commonly, we will use your 
              personal data in the following circumstances:
            </p>
            <ul>
              <li>To register you as a new customer.</li>
              <li>To process and deliver our e-signature services.</li>
              <li>To manage our relationship with you.</li>
              <li>To improve our website, products/services, marketing, or customer relationships.</li>
              <li>To recommend products or services that may be of interest to you.</li>
              <li>To comply with legal obligations.</li>
            </ul>
          </section>
          
          <section className="policy-section">
            <h2>4. Data Security</h2>
            <p>
              We have put in place appropriate security measures to prevent your personal data from being 
              accidentally lost, used, or accessed in an unauthorized way, altered, or disclosed. We limit 
              access to your personal data to those employees, agents, contractors, and other third parties 
              who have a business need to know. They will only process your personal data on our instructions, 
              and they are subject to a duty of confidentiality.
            </p>
            <p>
              We use industry-standard encryption technologies when transferring and receiving data. We also 
              maintain physical, electronic, and procedural safeguards to protect your personal data.
            </p>
          </section>
          
          <section className="policy-section">
            <h2>5. Data Retention</h2>
            <p>
              We will only retain your personal data for as long as necessary to fulfill the purposes we 
              collected it for, including for the purposes of satisfying any legal, accounting, or reporting 
              requirements.
            </p>
            <p>
              To determine the appropriate retention period for personal data, we consider the amount, nature, 
              and sensitivity of the personal data, the potential risk of harm from unauthorized use or disclosure 
              of your personal data, the purposes for which we process your personal data, and whether we can 
              achieve those purposes through other means, and the applicable legal requirements.
            </p>
          </section>
          
          <section className="policy-section">
            <h2>6. Your Legal Rights</h2>
            <p>
              Under certain circumstances, you have rights under data protection laws in relation to your personal data, including:
            </p>
            <ul>
              <li>The right to request access to your personal data.</li>
              <li>The right to request correction of your personal data.</li>
              <li>The right to request erasure of your personal data.</li>
              <li>The right to object to processing of your personal data.</li>
              <li>The right to request restriction of processing your personal data.</li>
              <li>The right to request transfer of your personal data.</li>
              <li>The right to withdraw consent.</li>
            </ul>
            <p>
              If you wish to exercise any of these rights, please contact us using the details provided below.
            </p>
          </section>
          
          <section className="policy-section">
            <h2>7. Third-Party Links</h2>
            <p>
              This website may include links to third-party websites, plug-ins, and applications. Clicking on 
              those links or enabling those connections may allow third parties to collect or share data about 
              you. We do not control these third-party websites and are not responsible for their privacy 
              statements. When you leave our website, we encourage you to read the privacy policy of every 
              website you visit.
            </p>
          </section>
          
          <section className="policy-section">
            <h2>8. Cookies</h2>
            <p>
              We use cookies and similar tracking technologies to track the activity on our service and hold 
              certain information. Cookies are files with a small amount of data which may include an anonymous 
              unique identifier.
            </p>
            <p>
              You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. 
              However, if you do not accept cookies, you may not be able to use some portions of our service.
            </p>
          </section>
          
          <section className="policy-section">
            <h2>9. Changes to This Privacy Policy</h2>
            <p>
              We may update our privacy policy from time to time. We will notify you of any changes by posting 
              the new privacy policy on this page and updating the "last updated" date at the top of this 
              privacy policy.
            </p>
            <p>
              You are advised to review this privacy policy periodically for any changes. Changes to this 
              privacy policy are effective when they are posted on this page.
            </p>
          </section>
          
          <section className="policy-section">
            <h2>10. Contact Us</h2>
            <p>
              If you have any questions about this privacy policy, please contact us:
            </p>
            <ul>
              <li>By email: support@signinseconds.com</li>
              <li>By phone: +1 (555) 123-4567</li>
              <li>By mail: Sign in Seconds, 123 E-Signature Street, San Francisco, CA 94105, USA</li>
            </ul>
          </section>
        </div>
        
        <div className="policy-footer">
          <Link to="/">
            <Button variant="secondary">Back to Home</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
